<template>
  <div v-if="fetched && this.users" class="padding-zero">
    <div class="ml-2" style="font-size: 15px">
      <span>Średnie CLV:</span
      ><span class="ml-2" v-if="avgClv">{{ avgClv }}</span>
      <div v-else class="spinner-border text-secondary loader" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <table-header
      :filters="filteringOptions"
      :title="'Użytkownicy'"
      :withPagination="true"
      :withFilters="true"
      :dispatchAction="'getAllProfiles'"
      :onPage="this.users.pagination.on_page"
      :pageNumber="this.users.pagination.page_number"
      :total="this.users.pagination.total"
      :downloadAction="true"
      :refreshAction="true"
      :tableName="'users'"
      @selectedParam="selectedParamAction('emit', $event)"
      :withDownloadCheckbox="true"
    ></table-header>
    <!-- v-if=" this.users && this.users.data && this.users.pagination.total_value > 0" -->
    <table class="table table-striped table-sm">
      <thead>
        <tr style="width: 100%">
          <th scope="col">ID użytkownika</th>
          <th scope="col">Utworzono</th>
          <th scope="col">Imię</th>
          <th scope="col">Nazwisko</th>
          <th scope="col">Telefon</th>
          <th scope="col">Data urodzenia</th>
          <th scope="col">Pesel</th>
          <th scope="col">Adresy użytkownika</th>
          <th scope="col">Numer konta</th>
          <th scope="col">Weryfikacja numeru konta</th>
          <th scope="col">Status</th>
          <th scope="col">Dystans</th>
          <th scope="col">Zdjęcie</th>
          <th scope="col">Status pracownika</th>
          <th scope="col">Usługi</th>
          <th scope="col">Płatności</th>
          <th scope="col">Stan portfela</th>
          <th scope="col">CLV</th>
          <th scope="col">Wiadomość</th>
          <th scope="col">Szczegóły</th>
          <th scope="col">Ostatnia aktywność (system)</th>
          <th scope="col">Ostatnia aktywność (aplikacja)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="data in this.users.data" :key="data.id">
          <td>{{ data.id }}</td>
          <td>{{ formattedDate(data.creation_date) }}</td>

          <td>{{ data.first_name }}</td>
          <td>{{ data.last_name }}</td>
          <td>{{ data.phone }}</td>
          <td>
            {{
              data.birthdate ? formattedDateWithoutTime(data.birthdate) : "Brak"
            }}
          </td>
          <td>
            {{ data.pesel ? data.pesel : "Brak" }}
          </td>
          <td>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              :data-target="`#address${data.id}`"
            >
              Pokaż
            </button>
          </td>
          <td>
            {{ data.account_number ? data.account_number : "Brak" }}
          </td>
          <td
            v-if="
              !data.payment_verification_status ||
              data.payment_verification_status === 'NOT_INITIALIZED'
            "
          >
            Nie rozpoczęto płatności weryfikacyjnej
          </td>
          <td v-if="data.payment_verification_status === 'ACCEPTED'">
            Płatność weryfikacyjna zakończona pomyślnie
          </td>
          <td v-if="data.payment_verification_status === 'REJECTED'">
            Płatność weryfikacyjna zakończona niepowodzeniem
          </td>
          <td v-if="data.payment_verification_status === 'CREATED'">
            Płatność weryfikacyjna rozpoczęta, lecz niedokończona
          </td>

          <td>{{ data.profile_status }}</td>
          <td>{{ data.distance }}</td>
          <td>
            <a
              target="_blank"
              :href="getUrl() + '/api/profile/photo/' + data.file_path"
            >
              <img
                class="img-avatar"
                :src="getUrl() + '/api/profile/photo/' + data.file_path"
              />
            </a>
          </td>

          <!-- :src="requestPhoto(fileId)" -->
          <td>{{ data.employee_status }}</td>

          <td>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              :data-target="`#userServices${data.id}`"
              v-on:click="setCurrentUserServices(data.id)"
            >
              Usługi
            </button>
          </td>
          <td>
            <router-link
              :to="{
                name: 'PaymentsList',
                query: { search: data.phone },
              }"
            >
              <button type="button" class="btn btn-outline-dark mr-3">
                Płatności
              </button>
            </router-link>
          </td>
          <td>{{ data.wallet_amount }}</td>
          <td>
            <span v-if="usersClvs.find((uCLV) => uCLV.userId === data.id)">{{
              usersClvs.find((uCLV) => uCLV.userId === data.id).clv.toFixed(2)
            }}</span>
            <button
              v-else
              type="button"
              class="btn btn-outline-dark mr-3"
              @click="checkUserClv(data.id)"
            >
              Pokaż CLV
            </button>
          </td>

          <td>
            <router-link :to="{ path: '/chat/' + data.id }">
              <button type="button" class="btn btn-outline-dark mr-3">
                Napisz
              </button>
            </router-link>
          </td>
          <td>
            <router-link :to="{ path: 'users/id/' + data.id }">
              <button type="button" class="btn btn-outline-dark mr-3">
                Przejdź
              </button>
            </router-link>
          </td>

          <td>
            {{ data.last_os }}
          </td>

          <td>
            {{ data.last_app }}
          </td>

          <div
            class="modal fade"
            :id="`userServices${data.id}`"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl modal-xl" role="dialog">
              <div class="modal-content services-modal">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Usługi użytkownika
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <table class="table modal-table">
                    <thead>
                      <tr class="tr-table">
                        <th scope="col">ID</th>
                        <th scope="col">Cena</th>
                        <th scope="col">ID usługi</th>
                        <th scope="col">Nazwa</th>
                        <th scope="col">Opis</th>
                        <th scope="col">Pierwszy próg</th>
                        <th scope="col">Drugi próg</th>
                        <th scope="col">Typ</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="item in currentUserServices"
                        v-bind:key="item.id"
                      >
                        <td>{{ item.id }}</td>
                        <td>{{ item.price }}</td>
                        <td>{{ item.id }}</td>
                        <td>{{ item.display_name }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.first_threshold }}</td>
                        <td>{{ item.second_threshold }}</td>
                        <td>{{ item.type }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    data-dismiss="modal"
                  >
                    Zamknij
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Adresy użytkownika -->
          <div
            class="modal fade"
            :id="`address${data.id}`"
            tabindex="-1"
            role="dialog"
            aria-labelledby="address"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="address">Adresy użytkownika</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="changes = null"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <h4>Adres do faktury</h4>
                  <table class="table modal-table">
                    <thead>
                      <tr class="tr-table">
                        <th scope="col">Kod pocztowy</th>
                        <th scope="col">Miasto</th>
                        <th scope="col">Ulica</th>
                        <th scope="col">Numer budynku</th>
                        <th scope="col">Numer mieszkania</th>
                        <th scope="col">Piętro</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>
                          {{
                            data.postcode_invoice
                              ? data.postcode_invoice
                              : "Brak"
                          }}
                        </td>
                        <td>
                          {{ data.city_invoice ? data.city_invoice : "Brak" }}
                        </td>
                        <td>
                          {{
                            data.street_invoice ? data.street_invoice : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.number1_invoice ? data.number1_invoice : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.number2_invoice ? data.number2_invoice : "Brak"
                          }}
                        </td>
                        <td>
                          {{ data.floor_invoice ? data.floor_invoice : "Brak" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <h4>Adres świadczenia usług</h4>
                  <table class="table modal-table">
                    <thead>
                      <tr class="tr-table">
                        <th scope="col">Kod pocztowy</th>
                        <th scope="col">Miasto</th>
                        <th scope="col">Ulica</th>
                        <th scope="col">Numer budynku</th>
                        <th scope="col">Numer mieszkania</th>
                        <th scope="col">Piętro</th>
                        <th scope="col">Latitude</th>
                        <th scope="col">Longitude</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>
                          {{
                            data.employee_postcode
                              ? data.employee_postcode
                              : "Brak"
                          }}
                        </td>
                        <td>
                          {{ data.employee_city ? data.employee_city : "Brak" }}
                        </td>
                        <td>
                          {{
                            data.employee_street ? data.employee_street : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.employee_number1
                              ? data.employee_number1
                              : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.employee_number2
                              ? data.employee_number2
                              : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.employee_floor ? data.employee_floor : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.employee_latitude
                              ? data.employee_latitude
                              : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.employee_longitude
                              ? data.employee_longitude
                              : "Brak"
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <span v-if="data.distance && data.postcode">
                    Promień świadczenia usług:
                    {{ data.distance }}km
                  </span>
                </div>

                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    data-dismiss="modal"
                    @click="changes = null"
                  >
                    Zamknij
                  </button>
                </div>
              </div>
            </div>
          </div>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "../axios";
import { URL } from "../axios";
import shared from "../shared";
import TableHeader from "../components/TableHeader.vue";
/* import SortingPanel from '../components/SortingPanel.vue'; */
export default {
  name: "Users",
  components: {
    TableHeader,
  },

  computed: {
    users() {
      return this.$store.getters.getUsers;
    },
    userServices() {
      return this.$store.getters.getUserServices;
    },
    notification() {
      return this.$store.getters.getNotificationResponse;
    },
    filterParam() {
      return this.$store.getters.getFilterParameter;
    },
  },
  async created() {
    this.getUsersAvgClv();
    await axios.get(`api/user/start`).then((response) => {
      const {
        phone,
        id,
        has_dod_access,
        has_pod_access,
      } = response.data.user.user_response;
      const { first_name, last_name } = response.data.user.profile_response;
      const adminData = {
        id,
        phone,
        firstName: first_name,
        lastName: last_name,
        hasDodAccess: has_dod_access,
        hasPodAccess: has_pod_access,
      };
      this.$store.commit("SET_LOGGED_ADMIN", adminData);
      window.localStorage.setItem("loggedAdmin", JSON.stringify(adminData));

      this.$store.commit(
        "SET_LOGGED_USER",
        response.data.user.user_response.phone
      );
      window.localStorage.setItem(
        "loggedUser",
        response.data.user.user_response.phone
      );
    });
    await this.$store.dispatch("getAllProfiles", {
      on_page: this.users.pagination.on_page,
      page_number: this.users.pagination.page_number,
    });
    await this.$store.dispatch("getUserServices");
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
    this.formattedDate = shared.formattedDate;
    this.fetched = true;
  },
  methods: {
    async getUsersAvgClv() {
      const response = await axios.get(`/api/admin/avgClvUsers`);
      if (response && response.data) {
        this.avgClv = response.data.clv.toFixed(2);
      }
    },
    async checkUserClv(userId) {
      const response = await axios.get(`/api/admin/clvUser/${userId}`);
      if (response && response.data) {
        this.usersClvs.push({
          userId,
          clv: response.data.clv,
        });
      }
    },
    selectedParamAction(emit, e) {
      this.searchParam = e.selectedParam;
    },
    getUrl() {
      return URL;
    },
    requestPhoto(id) {
      let url = "api/profile/photo/" + id;
      axios.get(url).then((response) => {
        const img = Buffer.from(response.data, "binary").toString("base64");
        return "data:image/png;base64," + img;
      });
    },

    async setCurrentUserServices(userId) {
      const response = await axios.get(`api/userService/${userId}/noWaiting`);
      if (response && response.data) {
        this.currentUserServices = response.data;
      } else {
        this.currentUserServices = [];
      }
    },
    setCurrentUsers(data) {
      this.firstName = data.first_name;
      this.lastName = data.last_name;
      this.userId = data.id;
    },
  },

  data() {
    return {
      loading: false,
      fetched: false,
      currentUserServices: [],
      firstName: "",
      lastName: "",
      selectedService: "",
      userId: "",
      searchParam: "",
      filteringOptions: [
        {
          name: "",
          displayName: "Wszystkie",
          icon: "",
        },
        {
          name: "NONE",
          displayName:
            "Bez statusu - nowo utworzony użytkownik, nie rozpoczynał weryfikacji",
        },
        {
          name: "ACCEPTED",
          displayName:
            "Zweryfikowany - zaakceptowany przez admin, może świadczyć usługi",
        },
        {
          name: "REJECTED",
          displayName: "Niezaakceptowany - niezaakceptowany przez admina",
        },
        {
          name: "WAITING",
          displayName:
            "Użytkownicy, którzy po zweryfikowaniu zmienili swoje imię, nazwisko lub nr konta",
        },
        {
          name: "WAITING_WITHOUT_PAYMENT",
          displayName: "Bez rozpoczętej płatności",
        },
        {
          name: "WAITING_WITH_STARTED_PAYMENT",
          displayName: "Z rozpoczętą, niedokończoną płatnością",
        },
        {
          name: "deleted",
          displayName: "Użytkownicy usunięci",
        },
        {
          name: "blocked",
          displayName: "Użytkownicy zablokowani",
        },
      ],
      usersClvs: [],
      avgClv: 0,
    };
  },
};
</script>

<style scoped></style>
